import script from "./softwareTable.vue?vue&type=script&setup=true&lang=js"
export * from "./softwareTable.vue?vue&type=script&setup=true&lang=js"

import "./softwareTable.vue?vue&type=style&index=0&id=8a313c0c&lang=css"

const __exports__ = script;

export default __exports__